import { render, staticRenderFns } from "./PriceOrderAutograph.vue?vue&type=template&id=4a06c470&scoped=true&"
import script from "./PriceOrderAutograph.vue?vue&type=script&lang=js&"
export * from "./PriceOrderAutograph.vue?vue&type=script&lang=js&"
import style0 from "./PriceOrderAutograph.vue?vue&type=style&index=0&id=4a06c470&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a06c470",
  null
  
)

export default component.exports